import React, { useContext } from 'react';
import PageLayout from '../../components/common/page-layout';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { ModalContext } from '../../contexts/modal';
import NewPartForm from '../../components/inventory/insert-device-list-form';
import PartsTable from '../../components/tables/parts-table';
import { Stack } from '@mui/material';
import SubmitDeviceDetailsForm from '../../components/inventory/submit-details-form';

export default function Insert() {
  const { setOpen, setContent, setTitle } = useContext(ModalContext);

  function openDeviceListModal() {
    setContent(<NewPartForm />);
    setTitle('ثبت لیست دستگاه‌ها');
    setOpen(true);
  }

  function openRegisterDeviceModal() {
    setContent(<SubmitDeviceDetailsForm />);
    setTitle('ثبت اطلاعات دستگاه');
    setOpen(true);
  }

  return (
    <PageLayout pageTitle="افزودن موجودی">
      <Grid container gap={3}>
        <Grid>
          <Stack direction="row" spacing={2}>
            <Button variant="contained" onClick={openDeviceListModal}>
              ثبت لیست دستگاه‌ها
            </Button>
            <Button variant="contained" onClick={openRegisterDeviceModal}>
              افزدون اطلاعات دستگاه‌ها
            </Button>
          </Stack>
        </Grid>
        <Grid component={Paper} item xs={12} minHeight="400px">
          <PartsTable />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
